// extracted by mini-css-extract-plugin
module.exports = {"container":"source_container__ijgrx","text":"source_text__HG2FT"};